'use strict';

$ = jQuery;

/*
 Conta o envio de leads submetidos
 Essa função é chamada na resposta do ajax que salva leads.
 */

function gtm_send_lead_saved(data) {
  // E-commerce - Purchase
  dataLayer.push({
    'event': 'leadSent',
    'eventCategory': data.context,
    'eventAction': 'Envio de lead',
    'ecommerce': {
      'purchase': {
        'actionField': {
          'id': data.leadId,
          'affiliation': data.affiliation,
          'revenue': data.price,
          'coupon': data.campaign
        },
        'products': [{
          'name': data.name,
          'id': data.id,
          'price': data.price,
          'brand': data.brand,
          'category': data.category,
          'quantity': 1,
          'coupon': data.campaign
        }]
      }
    }
  });

  gtag('event', 'leadSent', {
    'eventCategory': data.context,
    'eventAction': 'Envio de lead',
    'ecommerce': {
      'purchase': {
        'actionField': {
          'id': data.leadId,
          'affiliation': data.affiliation,
          'revenue': data.price,
          'coupon': data.campaign
        },
        'products': [{
          'name': data.name,
          'id': data.id,
          'price': data.price,
          'brand': data.brand,
          'category': data.category,
          'quantity': 1,
          'coupon': data.campaign
        }]
      }
    }
  });
}

/*
Conta as falhas no envio de leads submetidos
Essa função é chamada na resposta do ajax que salva leads.
*/

function gtm_send_lead_error(context, name) {
  dataLayer.push({
    'event': 'leadSendError',
    'eventCategory': context,
    'eventAction': 'Falha no envio de lead',
    'eventLabel': name
  });

  gtag('event', 'leadSendError', {
    'eventCategory': context,
    'eventAction': 'Falha no envio de lead',
    'eventLabel': name
  });
}

/**
 Busca dados do lead pelo lead id e o contexto
 */
function gtm_get_data_and_send_lead_saved(leadId, context) {

  return new Promise(function (resolve, reject) {

    $.ajax({
      url: ajaxHandler.url,
      type: 'POST',
      data: {
        action: 'jc_ajax_get_data_gtm_lead',
        leadId: leadId,
        context: context
      },
      success: function success(response) {
        gtm_send_lead_saved(response.data);
        resolve();
      },
      error: function error(data) {
        reject();
      }
    });
  });
}

// Envia evento de submissão de formulário - Lead enviado
function send_lead_saved_gtm_event() {
  // Lead enviado
  dataLayer.push({
    'event': 'lead_sent'
  });

  gtag('event', 'lead_sent');
}

// Envia evento de erro em formulário - Lead não enviado
function send_lead_error_gtm_event() {
  // Lead com erro
  dataLayer.push({
    'event': 'track-error-lead'
  });

  gtag('event', 'track-error-lead');
}

//dispara eventos de leads da primeira etapa de oferta 
function send_offer_lead_first_step_events() {
  dataLayer.push({
    'event': 'leadTrackingFirstStep'
  });

  gtag('event', 'leadTrackingFirstStep');
}

function send_lead_tracking_event() {
  dataLayer.push({
    'event': 'leadTracking'
  });

  gtag('event', 'leadTracking');
}

function send_data_layer_estadao_lead_event(products) {

  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'conversao',
    'genericAction': 'botao_consultar_oferta',
    'genericLabel': 'sucesso'
  });

  dataLayerEstadao.push({
    'event': 'forcePvPurchase',
    'page': '/lead',
    'ecommerce': {
      'purchase': {
        'actionField': {
          'id': 'transactionId',
          'affiliation': 'transactionAffiliation',
          'revenue': 'transactionRevenue',
          'tax': 'transactionTax',
          'shipping': 'transactionShipping',
          'coupon': 'transactionCoupon'
        },
        'products': products
      }
    }
  });

  gtag('event', 'conversao', {
    'genericAction': 'botao_consultar_oferta',
    'genericLabel': 'sucesso'
  });

  gtag('event', 'forcePvPurchase', {
    'page': '/lead',
    'ecommerce': {
      'purchase': {
        'actionField': {
          'id': 'transactionId',
          'affiliation': 'transactionAffiliation',
          'revenue': 'transactionRevenue',
          'tax': 'transactionTax',
          'shipping': 'transactionShipping',
          'coupon': 'transactionCoupon'
        },
        'products': products
      }
    }
  });
}

function send_data_layer_estadao_lead_error_event() {
  dataLayerEstadao.push({
    'event': 'genericEvent',
    'genericCategory': 'conversao',
    'genericAction': 'botao_consultar_oferta',
    'genericLabel': 'erro'
  });

  gtag('event', 'conversao', {
    'genericAction': 'botao_consultar_oferta',
    'genericLabel': 'erro'
  });
}